import { useForm } from 'react-hook-form';
import { useGetTelephone } from './useGetTelephone';
import { useGetBarcode } from './useGetBarcode';
import {
  channelBuyQuery,
  mobileBrandQuery,
} from '../../../../services/react-query/optionMasterQuery';
import { useCallback, useState } from 'react';
import { useRegAdd } from './useRegAdd';
import { handleSubmitForm } from '../function/submitHandler';
import { useGetWarrantyCode } from './useGetWarrantyCode';
import { openAlert } from '../../../../components/alert/hooks';

export const useGetRegAddList = () => {
  const { control, getValues, setValue, reset, handleSubmit } = useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [dataBarcode, setDataBarCode] = useState(null);
  const { mutate: onCallTele, loading: isCallingTele } = useGetTelephone({ getValues, reset });
  const { mutate: onCallBarcode, loading: isCallingBarcode } = useGetBarcode({ getValues, reset });
  const { mutate: onAddWarranty, loading: isOnAddLoading } = useRegAdd({ reset });
  const {
    mutate: onGetWarrantyCode,
    loading: isCallingWarrantyCode,
    dataSource: dataSourceWarrantyCode,
  } = useGetWarrantyCode();
  const { data: mobileBrandList } = mobileBrandQuery();
  const { data: channelBuyList } = channelBuyQuery();

  const onEnterTele = (tele) => {
    onCallTele(tele);
  };

  const onEnterBarcode = (value) => {
    // reset previous barcode state before new lookup
    setDataBarCode(null);
    onCallBarcode(value, {
      onSuccess: (data) => {
        setDataBarCode(data);
      },
      onError: () => {
        setDataBarCode(null);
      },
    });
  };

  const onSubmit = async (values) => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      await handleSubmitForm(values, onAddWarranty, dataBarcode, dataSourceWarrantyCode);
    } catch (error) {
      console.error('Error submitting form:', error);
      openAlert({ model: 'message', type: 'error', message: error.message });
    } finally {
      setTimeout(() => {
        setIsSubmitting(false);
      }, 1000);
    }
  };

  const onEnterWarrantyCode = useCallback(
    (warrantyCode) => {
      const barcode = getValues('barcodeShortcut');
      onGetWarrantyCode({ warrantyCode, barcode });
    },
    [getValues, onGetWarrantyCode],
  );

  return {
    control,
    getValues,
    setValue,
    reset,
    onEnterTele,
    isCallingTele,
    onEnterBarcode,
    isCallingBarcode,
    mobileBrandList,
    channelBuyList,
    onSubmit,
    isSubmitting,
    handleSubmit,
    isOnAddLoading,
    dataBarcode,
    isCallingWarrantyCode,
    onEnterWarrantyCode,
  };
};
